import { NgModule } from '@angular/core';
import {OnlyNumberDirective} from './only-number.directive';
import {InputRestrictionDirective} from './input-restriction.directive';
import {SortableHeaderDirective} from './sortable-header.directive';
import {NoSpacesDirective} from './no-spaces.directive';
import {DkkPipe} from './dkk.pipe';

@NgModule({
    imports: [],
    declarations: [OnlyNumberDirective, InputRestrictionDirective, SortableHeaderDirective, NoSpacesDirective, DkkPipe],
    exports: [OnlyNumberDirective, InputRestrictionDirective, SortableHeaderDirective, NoSpacesDirective, DkkPipe]
})

export class DirectivesModule { }
